module.exports = __webpack_public_path__ + "static/img/section-case-bg.dccfacd1.png";